// Used to disable disable some features or components
// without removing the code or commenting it out.
export const DISABLED = false;


// Used to set the debounce delay for input fields
// to prevent excessive re-rendering or API calls.
export const DEBOUNCE_DELAY = 500; // milliseconds


// Used to set a delay for refresh actions
// to improve user experience.
export const REFRESH_DELAY = 500; // milliseconds


// Used to set the height of the table rows
export const TABLE_ROW_HEIGHT = 49; // pixels
